import translationsEn from '../bundled-translations/en.json';
import translationsFi from '../bundled-translations/fi.json';
import translationsSv from '../bundled-translations/sv.json';
(function () {
  angular.module('sis-common.translations', []).constant('sisCommonTranslationsBundled', {
    en: translationsEn,
    fi: translationsFi,
    sv: translationsSv
  });
})();